import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { IDiscountCode } from './typings'
import { getDiscountCodes } from './api'

const discountCodeAdapter = createEntityAdapter<IDiscountCode>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = discountCodeAdapter.getInitialState()

const sources = createSlice({
  name: 'discountCode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDiscountCodes.pending, (state) => {
      discountCodeAdapter.removeAll(state)
    })
    builder.addCase(getDiscountCodes.fulfilled, (state, { payload }) =>
      discountCodeAdapter.setAll(state, payload),
    )
  },
})

export default sources.reducer

export const {
  selectAll: selectAllDiscountCodes,
  selectById: selectDiscountCodeById,
} = discountCodeAdapter.getSelectors<StoreData>((state) => state.discountCode)
